const transformVenue = (restaurant) => ({
  activeNotifications:
    restaurant.notifies?.reduce((notifies, item) => {
      notifies[item.service_type_id] = item;
      return notifies;
    }, {}),
  availableServiceTypes: Object.keys(restaurant.venue?.service_types || {}),
  averagePriceStr: restaurant.venue?.ticket?.average_str,
  collections: restaurant.venue?.collections,
  cuisine: restaurant.venue?.type,
  currencyDict: restaurant.venue?.currency,
  currency: restaurant.venue?.currency_symbol,
  events: restaurant.venue?.events,
  favorite: restaurant.venue?.favorite,
  gdaConciergeBooking: restaurant.venue?.gda_concierge_booking,
  id: restaurant.venue?.id?.resy,
  images: Object.values(restaurant?.templates || {}).reduce((images, item) => {
    if (item.images?.length > 0) images = images?.concat(item.images);
    return images;
  }, []),
  isGda: restaurant.venue?.is_global_dining_access,
  platinumNightDate: restaurant.venue?.platinum_night_date,
  platinumNightStatus: restaurant.venue?.platinum_night_status,
  location: {
    code: restaurant.venue?.location?.code,
    neighborhood: restaurant.venue?.location?.neighborhood,
    name: restaurant.venue?.location?.name,
    urlSlug: restaurant.venue?.location?.url_slug,
  },
  name: restaurant.venue?.name,
  priceRange: restaurant.venue?.price_range,
  rating: restaurant.venue?.rating,
  reopen: restaurant.venue?.reopen,
  responsiveImages: restaurant.venue?.responsive_images,
  source: restaurant.venue?.source,
  totalRatings: restaurant.venue?.total_ratings,
  urlSlug: restaurant.venue?.url_slug,
  whyWeLikeIt: {
    breadcrumbs: restaurant.content,
  },
});
export default transformVenue;
